import { FC } from "react";
import { useIntl } from "react-intl";
import { DefaultButton, Dialog, DialogFooter, PrimaryButton } from "@fluentui/react";
import { FixedList } from "cayo.ui";
import { useSelectServicesDialog } from "@cayo/core/admin-components/grids/SpnGrid/components/SelectServicesDialog/useSelectServicesDialog";
import { spnGridMessages } from "@cayo/core/admin-components/grids/SpnGrid/messages";
import { ISpnGridItem } from "@cayo/core/admin-components/grids/SpnGrid/types";
import { commonMessages } from "@cayo/shared/messages/common";

interface SelectServicesDialogProps {
  cayoObjId: string;
  isDialogVisible: boolean;
  dismissDialog: () => void;
  onConfirm: (services: ISpnGridItem[]) => void;
}

const SelectServicesDialog: FC<SelectServicesDialogProps> = ({
  cayoObjId,
  isDialogVisible,
  dismissDialog,
  onConfirm,
}) => {
  const { formatMessage } = useIntl();
  const {
    services,
    selectedServices,
    setSelectedServices,
    columns,
    isLoading,
    resolveExpandedFromSelected,
  } = useSelectServicesDialog(cayoObjId);

  return (
    <Dialog
      hidden={!isDialogVisible || isLoading}
      minWidth={1000}
      dialogContentProps={{
        title: formatMessage(spnGridMessages.selectServices),
      }}
      modalProps={{
        isBlocking: true,
      }}
      onDismiss={dismissDialog}
    >
      <FixedList
        name="services-list"
        layoutMode="fixedColumns"
        selectionMode="multiple"
        value={services}
        columns={columns as any}
        setValue={() => {}}
        onSelectedItemsChange={(items) => setSelectedServices(items ?? [])}
      />
      <DialogFooter>
        <PrimaryButton
          onClick={() => {
            onConfirm(resolveExpandedFromSelected(selectedServices));
            dismissDialog();
          }}
          text={formatMessage(commonMessages.ok)}
          disabled={!selectedServices.length}
        />
        <DefaultButton onClick={dismissDialog} text={formatMessage(commonMessages.cancel)} />
      </DialogFooter>
    </Dialog>
  );
};

export default SelectServicesDialog;
